import { memo, useEffect, useRef, useState } from "react";
import { styled } from "styletron-react";
import { colors, fonts } from "../../../Styles";

interface PathProps {
  $isSelected?: boolean;
  $locationVisual?: number;
  $attentionLevel?: number;
}

const StationPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: colors.greyTertiary,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)"
}))

const AttentionPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: props.$attentionLevel !== undefined && props.$attentionLevel === 0 ? colors.systemRed : props.$attentionLevel === 5 ? colors.graphBlueTwo : colors.systemYellow,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)",
  transformOrigin: props.$locationVisual !== undefined && props.$locationVisual >= 3 ? "0 50%" : "100% 50%", 
  transform: "scaleX(0)",      
  animation: "expand 0.5s forwards",
  "@keyframes expand": {
    "0%": { transform: "scaleX(0)" },
    "100%": { transform: "scaleX(1)" },
  },
}))

const ArrowPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: colors.whitePrimary,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)",
}))

export const StationLocationVisual = memo(({ content, attention, locationVisual, gridArea, onClick, isSelected = false}: { content: string | JSX.Element, attention?: number, locationVisual: number, gridArea?: string, onClick?: () => void, isSelected?: boolean }) => {
  // const [animateAttention, setAnimateAttention] = useState(false);
  // const prevAttention = useRef<number | undefined>(undefined);

  // useEffect(() => {
  //   if (prevAttention.current !== attention) {
  //     setAnimateAttention(true);
  //     prevAttention.current = attention;
  //     // Stop animation after it finishes
  //     const timeout = setTimeout(() => setAnimateAttention(false), 500);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [attention]);
  
  // const StationPathStyle = styled("path", {
  //   stroke: "none",
  //   fill: colors.greyTertiary,
  //   filter: isSelected ? "opacity(1)" : "opacity(0.5)"
  // })

  // const AttentionPathStyle = styled("path", {
  //   stroke: "none",
  //   fill: colors.systemRed,
  //   filter: isSelected ? "opacity(1)" : "opacity(0.5)",
  //   transformOrigin: locationVisual >= 3 ? "0 50%" : "100% 50%", 
  //   transform: animateAttention ? "scaleX(0)" : "scaleX(1)",      
  //   animation: animateAttention ? "expand 0.5s forwards" : "none",
  //   "@keyframes expand": {
  //     "0%": { transform: "scaleX(0)" },
  //     "100%": { transform: "scaleX(1)" },
  //   },
  // })

  // const ArrowPathStyle = styled("path", {
  //   stroke: "none",
  //   fill: colors.whitePrimary,
  //   filter: isSelected ? "opacity(1)" : "opacity(0.5)",
  // })

  let stationPath: string = "";
  let attentionPath:string = "";
  let firstArrowPath:string = "";
  let secondArrowPath: string = "";

  switch (locationVisual) {
    case 2:
      stationPath = "M118 8V34C118 35.6569 116.657 37 115 37H25.2774C24.7675 37 24.2661 37.1299 23.8204 37.3775L18.239 40.4784C16.7459 41.3078 14.8626 40.7252 14.0988 39.1975L1.26917 13.5383C0.55712 12.1142 1.08162 10.3819 2.46404 9.59198L9.80828 5.39527C10.2616 5.13625 10.7746 5 11.2967 5H115C116.657 5 118 6.34315 118 8Z"
      firstArrowPath = "M15.1865 31.8927L20.8454 22.8927L22.2834 25.7535L32.0241 20.8575L34.0883 24.9643L24.3475 29.8602L25.7854 32.721L15.1865 31.8927Z"
      secondArrowPath = "M9.78072 21.1793L15.4397 12.1793L16.8776 15.0401L26.6183 10.1441L28.6825 14.2509L18.9418 19.1469L20.3797 22.0077L9.78072 21.1793Z"
      attentionPath = "M118 34V8C118 6.34315 116.657 5 115 5H108V37H115C116.657 37 118 35.6569 118 34Z"
    break
    case 3:
      stationPath = "M0 34V8C0 6.34315 1.34315 5 3 5H92.7226C93.2325 5 93.7339 4.87007 94.1796 4.62247L99.761 1.52165C101.254 0.692175 103.137 1.27481 103.901 2.80248L116.731 28.4617C117.443 29.8858 116.918 31.6181 115.536 32.408L108.192 36.6047C107.738 36.8638 107.225 37 106.703 37H3C1.34315 37 0 35.6569 0 34Z"
      firstArrowPath = "M102.814 10.1073L97.1546 19.1073L95.7166 16.2465L85.9759 21.1425L83.9117 17.0357L93.6525 12.1398L92.2146 9.27897L102.814 10.1073Z"
      secondArrowPath = "M108.219 20.8207L102.56 29.8207L101.122 26.9599L91.3817 31.8559L89.3175 27.7491L99.0582 22.8531L97.6203 19.9923L108.219 20.8207Z"
      attentionPath = "M0 34V8C0 6.34315 1.343 5 3 5H10V37H3C1.343 37 0 35.6569 0 34Z"
      break
    case 4:
      stationPath = "M0 8V34C0 35.6569 1.34315 37 3 37H92.7226C93.2325 37 93.7339 37.1299 94.1796 37.3775L99.761 40.4784C101.254 41.3078 103.137 40.7252 103.901 39.1975L116.731 13.5383C117.443 12.1142 116.918 10.3819 115.536 9.59198L108.192 5.39527C107.738 5.13625 107.225 5 106.703 5H3C1.34315 5 0 6.34315 0 8Z"
      firstArrowPath = "M102.814 31.8927L97.1546 22.8927L95.7166 25.7535L85.9759 20.8575L83.9117 24.9643L93.6525 29.8602L92.2146 32.721L102.814 31.8927Z"
      secondArrowPath = "M108.219 21.1793L102.56 12.1793L101.122 15.0401L91.3817 10.1441L89.3175 14.2509L99.0582 19.1469L97.6203 22.0077L108.219 21.1793Z"
      attentionPath = "M0 34V8C0 6.34315 1.343 5 3 5H10V37H3C1.343 37 0 35.6569 0 34Z"
      break
    case 1:
    default:
      stationPath = "M118 34V8C118 6.34315 116.657 5 115 5H25.2774C24.7675 5 24.2661 4.87007 23.8204 4.62247L18.239 1.52165C16.7459 0.692175 14.8626 1.27481 14.0988 2.80248L1.26917 28.4617C0.55712 29.8858 1.08162 31.6181 2.46404 32.408L9.80828 36.6047C10.2616 36.8638 10.7746 37 11.2967 37H115C116.657 37 118 35.6569 118 34Z"
      attentionPath = "M118 34V8C118 6.34315 116.657 5 115 5H108V37H115C116.657 37 118 35.6569 118 34Z"
      firstArrowPath = "M15.1865 10.1073L20.8454 19.1073L22.2834 16.2465L32.0241 21.1425L34.0883 17.0357L24.3475 12.1398L25.7854 9.27897L15.1865 10.1073Z"
      secondArrowPath = "M9.78072 20.8207L15.4397 29.8207L16.8776 26.9599L26.6183 31.8559L28.6825 27.7491L18.9418 22.8531L20.3797 19.9923L9.78072 20.8207Z"
    break
  } 

  return (
    <div style={{ position: "relative", cursor: "pointer", height: "37px", width: "118px", gridArea: gridArea ? gridArea : "" }} onClick={onClick ? onClick : undefined}>
      <svg viewBox="0 0 118 37">
        <StationPathStyle d={stationPath} $isSelected={isSelected}/>
        <ArrowPathStyle d={firstArrowPath} $isSelected={isSelected}/>
        <ArrowPathStyle d={secondArrowPath} $isSelected={isSelected}/>
        { attention !== undefined && <AttentionPathStyle d={attentionPath} $locationVisual={locationVisual} $isSelected={isSelected} $attentionLevel={attention}/>}
      </svg>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        inset: locationVisual >= 3 ? "5px 10px 0px 0px" : "5px 0px 0px 10px",
        backgroundColor: colors.transparent,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        color: colors.greyDarkPrimary,
        ...fonts.paragraph,
        ...fonts.fontSize4
      }}>
        {content}
      </div>
    </div>
  )
})